import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class PostResource extends AuthenticatedResource {
  static urlRoot = '/admin/posts'

  readonly id: number | undefined = undefined;
  
  pk() {
    return this.id?.toString();
  }
}